/**
 * Words for next year's objectives when they are agreed in this year's year-end check-in (HR UAT
 * list #27): the session about them follows the check-in (YearEndMeetingBanner), and a People
 * Leader approves them once that check-in starts.
 */

/** A booked time, as the People Leader reads it. */
export const when = (iso: string) =>
  new Date(iso).toLocaleString('en-ZA', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })

/**
 * Why a People Leader can't approve these yet, under each objective: the check-in is booked for
 * later, or not booked at all. `year` is the year the objectives are for.
 */
export function yearEndApprovalNote(session: { status: string; scheduled_date?: string | null }, year: number): string {
  const checkin = `${year - 1} year-end check-in`
  if (session.status === 'scheduled' && session.scheduled_date) {
    return `These are agreed in the ${checkin} on ${when(session.scheduled_date)}. You can approve them once it starts.`
  }
  return `These are agreed in the ${checkin}, which isn't booked yet. Book it on the People Leader Hub, then approve them once it starts.`
}
